module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "emit_above_planet_v4-1.27e631c8.png";